import {bindable, DOM, inject, PLATFORM} from 'aurelia-framework';
import {noop} from 'lodash';

/** @type {Function} */
let WheelHandlerImpl;

@inject(DOM.Element)
export class WheelCustomAttribute {

  @bindable disabled = false;
  @bindable callback = noop;

  private __wheelEvent: AbstractWheelHandler;
  private __listener: EventListener;

  constructor(private __targetEl: Element) {
    this.__wheelEvent = this.__makeWheelHandler(__targetEl);
  }

  bind() {
    if (!this.__wheelEvent) return;
    this.__targetEl.addEventListener(this.__wheelEvent.eventType(), this.__listener = e => {
      if (!this.disabled) {
        this.callback({e, delta: this.__wheelEvent.deltaY(e)});
      }
    });
  }

  unbind() {
    if (!this.__wheelEvent) return;
    this.__targetEl.removeEventListener(this.__wheelEvent.eventType(), this.__listener);
  }

  __makeWheelHandler(element: Element) {
    if (WheelHandlerImpl) {
      return new WheelHandlerImpl(element);
    }

    throw new Error('unsupported wheel event type');
  }

}

abstract class AbstractWheelHandler {

  abstract eventType(): string;

  abstract deltaY(event: Event): number;
}

class WheelHandler extends AbstractWheelHandler {

  lineHeight: number;

  constructor(element: Element) {
    super();
    this.lineHeight = WheelHandler.getLineHeight(element);
  }

  eventType() {
    return 'wheel';
  }

  deltaY(event) {
    // The delta values are specified in pixels
    if (event.deltaMode === 0) {
      return event.deltaY;
    }

    // The delta values are specified in lines
    if (event.deltaMode === 1) {
      return this.lineHeight * event.deltaY;
    }

    throw new Error('unexpected deltaMode');
  }

  /**
   * @param {Element} element
   * @returns {Number}
   * @static
   */
  static getLineHeight(element) {
    let target = element.offsetParent || element.parent || element;
    let style = DOM.getComputedStyle(target);
    return style && parseInt(style.fontSize, 10) || 16;
  }

}

class MouseWheelHandler extends AbstractWheelHandler {

  eventType() {
    return 'mousewheel';
  }

  deltaY(event) {
    return -event.wheelDelta;
  }

}

if ('onwheel' in PLATFORM.global) {
  WheelHandlerImpl = WheelHandler;
} else if ('onmousewheel' in PLATFORM.global) {
  WheelHandlerImpl = MouseWheelHandler;
}
